import React from 'react'
import Filter from 'uiComponents/filter'
import { getActiveAccount } from 'preferences/selectors'
import { useAppSelector } from 'store/hooks'
import { FilterCategory } from 'uiComponents/filter/schema'
import { capitalize } from 'lodash'

const filtersToMetaData = (filters: Record<string, string[]>) => Object.entries(filters).map(([key, value]) => ({
    category: key as FilterCategory,
    options: value.map((slug) => ({
        name: capitalize(slug),
        slug,
        category: key as FilterCategory,
        parents: [],
        children: [],
        leafNode: true,
    })),
}))

const membershipFilters = {
    membership_status: ['active', 'inactive', 'overdue'],
}

const MembershipsTableFilters = () => {
    const accountSlug = useAppSelector(getActiveAccount)

    if (!accountSlug) throw new Error('No account selected')

    return (
        <div className="filter">
            <Filter
                accountSlug={accountSlug}
                applicableFilters={['membership_status']}
                metaData={filtersToMetaData(membershipFilters)}
                standaloneFilters={[]}
                singleSelectCategories={[]}
                compact
            />
        </div>
    )
}

export default MembershipsTableFilters
